function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'blue-dusk': 'url("//lifewelllived.co.uk/cdn/shop/files/Dusk_68x.png?v=9632329357289775117")','black': 'url("//lifewelllived.co.uk/cdn/shop/files/Black_68x.png?v=10011647809600319637")','ice-grey': 'url("//lifewelllived.co.uk/cdn/shop/files/IceGrey_68x.png?v=15479347848121420157")','maroon': 'url("//lifewelllived.co.uk/cdn/shop/files/Maroon_68x.png?v=4606023373319149275")','military-green': 'url("//lifewelllived.co.uk/cdn/shop/files/MilitaryGreen_68x.png?v=6483519063645763293")','natural': 'url("//lifewelllived.co.uk/cdn/shop/files/Natural_68x.png?v=68244649613506103")','navy': 'url("//lifewelllived.co.uk/cdn/shop/files/Navy_68x.png?v=5025288042081782321")','prairie-dust': 'url("//lifewelllived.co.uk/cdn/shop/files/Dust_68x.png?v=10566808664304515418")','sand': 'url("//lifewelllived.co.uk/cdn/shop/files/Sand_68x.png?v=3102179272236208470")','stone-blue': 'url("//lifewelllived.co.uk/cdn/shop/files/StoneBlue_68x.png?v=5256563096750716584")','tan': 'url("//lifewelllived.co.uk/cdn/shop/files/Tan_68x.png?v=6116026253042885335")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
